import React from 'react';
import {
  Animated,
  Easing,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import ReactNativeHapticFeedback from 'react-native-haptic-feedback';

import Colors from '../theming/Colors';
import { colorForScheme } from '../theming/Theming';

const knobOffset = 16;

//******************************************************************************
// Types
//******************************************************************************
interface IProps {
  isOn: boolean;
  style?: any;
  onToggle: (isOn: boolean) => void;
}

interface IState {
  animatedValue: Animated.Value;
}

//******************************************************************************
// Component
//******************************************************************************

class KitToggle extends React.Component<IProps, IState> {
  //****************************************************************************
  // Static Properties
  //****************************************************************************
  static defaultProps = {
    isOn: false,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    onToggle: (isOn: boolean) => null,
  };

  //****************************************************************************
  // State
  //****************************************************************************
  state = {
    animatedValue: new Animated.Value(this.props.isOn ? knobOffset : 0),
  };

  //****************************************************************************
  // Methods
  //****************************************************************************

  handlePress = (): void => {
    ReactNativeHapticFeedback.trigger('impactMedium', {
      enableVibrateFallback: true,
      ignoreAndroidSystemSettings: false,
    });
    this.props.onToggle(!this.props.isOn);
  };

  //****************************************************************************
  // Lifecycle
  //****************************************************************************

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  componentDidUpdate = (prevProps: IProps) => {
    if (prevProps.isOn !== this.props.isOn) {
      Animated.timing(this.state.animatedValue, {
        toValue: this.props.isOn ? knobOffset : 0,
        easing: Easing.elastic(0.7),
        duration: 100,
        useNativeDriver: true,
      }).start();
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  render() {
    const { isOn } = this.props;
    const animatedStyle = {
      transform: [{ translateX: this.state.animatedValue }],
    };

    return (
      <TouchableOpacity
        testID='toggleWrapper'
        activeOpacity={1.0}
        style={[styles.toggleWrapper, this.props.style]}
        onPress={this.handlePress}
      >
        <View
          testID='toggleTrack'
          style={[
            styles.track,
            {
              backgroundColor: isOn
                ? colorForScheme({ default: Colors.brand })
                : colorForScheme({ default: Colors.N200 }),
            },
          ]}
        >
          <Animated.View
            testID='toggleKnob'
            style={[
              styles.knob,
              {
                backgroundColor: isOn
                  ? colorForScheme({ default: Colors.brand })
                  : colorForScheme({ default: Colors.N150 }),
              },
              animatedStyle,
            ]}
          />
        </View>
      </TouchableOpacity>
    );
  }
}
export default KitToggle;

//******************************************************************************
// Styles
//******************************************************************************
const styles = StyleSheet.create({
  toggleWrapper: {
    alignItems: 'center',
    borderRadius: 28,
    height: 56,
    width: 56,
    justifyContent: 'center',
  },
  track: {
    justifyContent: 'center',
    width: 28,
    height: 4,
    borderRadius: 14,
  },
  knob: {
    width: 16,
    height: 16,
    borderRadius: 32,
  },
});
